import { memo, useState } from "react"
import { InterUserSelectedProps } from "./types"
import { Box, Button, Checkbox, Divider, IconButton, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import Loader from "../../../../../../../../components/loader"
import { useStyles } from "./styles"
import { Virtuoso } from "react-virtuoso"
import { icons } from "../../../../../../../../utils/icons"
import { PageOptionGroup } from "../../../../utils/enums/page"
import SimpleModal from "../../../../../../../../components/modal/simpleModal"


const InterUserSelectedComponent = ({ mode, loading, usersSelected, deleteAllUser, deleteUser }: InterUserSelectedProps) => {

    const { t } = useTranslation()
    const styles = useStyles()
    const [selected, setSelected] = useState<number[]>([])

    const handleSelect = (id: number, checked: boolean) => {
        setSelected(prev =>
            checked
                ? [...prev, id]
                : prev.filter(x => x !== id)
        )
    }

    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description: string
        confirm: () => void
        cancel?: () => void
    }>({
        open: false,
        title: '',
        description: '',
        confirm: () => { }
    })

    const closeModal = () => { setModal(prev => ({ ...prev, open: false })) }

    const handleDeleteAll = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title:  t('userGroup.modal.titles.deleteAll'),
            description: t('userGroup.modal.description.deleteAll'),
            cancel: closeModal,
            confirm: () => {
                deleteAllUser?.(selected);
                setSelected([])
                closeModal()
            }
        }))
    }

    return (
        <Box>
            <Box sx={styles.containerTitle}>
                <Typography fontWeight={'bold'} sx={styles.title}>{t('userGroup.titles.userSelected')}</Typography>

                {!!selected.length &&
                    <Button onClick={handleDeleteAll} sx={styles.button} variant="contained">{t('general.delete')}</Button>
                }
            </Box>

            {loading ?
                <Loader /> :
                <Virtuoso
                    style={styles.list as any}
                    totalCount={usersSelected?.length}
                    components={{
                        EmptyPlaceholder: () => (
                            <Box>
                                <Typography sx={styles.empty}>
                                    {t('general.messages.emptyTable')}
                                </Typography>

                                <Divider sx={styles.divider} />
                            </Box>
                        ),
                    }}
                    itemContent={(index) => {
                        const user = usersSelected?.[index]
                        return (
                            <Box key={user.id} sx={[styles.userContainer, styles.userBox]}>
                                {icons('personFilled')}
                                <Box sx={styles.containerText}>
                                    <Typography>{user.name}</Typography>
                                    <Typography fontSize={14}>{user.rol}</Typography>
                                </Box>
                                {mode == PageOptionGroup.CREATE ?
                                    <IconButton className="closeIcon" onClick={() => { if (deleteUser) { deleteUser(user.id) } }} sx={styles.buttonClose}>{icons('simple-close')}</IconButton>
                                    :
                                    <Checkbox
                                        checked={selected.includes(user.id)}
                                        onChange={e => handleSelect(user.id, e.target.checked)}
                                    />
                                }
                            </Box>
                        )
                    }}
                />
            }

            <SimpleModal
                open={modal.open}
                close={() => { closeModal() }}
                removeClose={!modal?.cancel}
                title={modal.title}
                description={modal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                back={modal?.cancel ?? undefined}
                next={modal.confirm ?? closeModal}
            />
        </Box>
    )
}

export const InterUserSelected = memo(InterUserSelectedComponent)